const index = "conversation";

const conversationFolder = `${index}/folder`;
const externalConversation = `${index}/external-message`;

const getConversationbyId = (id: string | number) => `${index}/${id}`;
const getConversationFolderById = (conversation_folder_id: string | number) =>
  `${conversationFolder}/${conversation_folder_id}`;

const getConversationMessageById = (id: string | number) => `${getConversationbyId(id)}/message`;
const getConversationExternalMessageById = (id: string | number, subdomain: string) =>
  `${getConversationbyId(id)}/external-message/${subdomain}`;
const getConversationMoveById = (id: string | number) => `${getConversationbyId(id)}/move`;
const getExternalConversation = (subdomain: string | null) => `${externalConversation}/${subdomain}`;

export const conversationEndpoint = Object.freeze({
  conversation: index,
  getExternalConversation,

  conversationRecipients: `${index}/recipients`,
  conversationSidebar: `${index}/conversation-sidebar`,
  conversationInbox: `${index}/inbox`,
  conversationFavorites: `${index}/favorites`,
  conversationTrash: `${index}/trash`,

  getConversationbyId,
  getConversationMessageById,
  getConversationExternalMessageById,
  getConversationFolderById,
  getConversationMoveById,
});
